import { useMutation } from '@tanstack/react-query';

import { MembershipCloudUserFormSchemaValues } from 'src/features/membershipCloudUsers/utils/formSchema';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralAxiosError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership/:membershipId/cloud-users/`;

type MutationFnType = typeof mutationFn;

interface DTO extends MembershipCloudUserFormSchemaValues {
    parkingId: string;
    membershipId: string;
}

const mutationFn = ({ parkingId, membershipId, ...data }: DTO): Promise<void> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, membershipId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralAxiosError<{ email: string[] }>>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateMembershipCloudUser };
